export const USER_ACCESS_TOKEN = 'user-token';
export const USER_ID_COOKIE_NAME = 'USER_UUID';
